import { createSlice } from "@reduxjs/toolkit";

const portalUsers = createSlice({
  name: "portalUsers",
  initialState: {
    portalUsers: [],
  },

  reducers: {
    setPortalUsers: (state, action) => {
      state.portalUsers = action.payload;
    },
  },
});

export const { setPortalUsers } = portalUsers.actions;

export default portalUsers.reducer;
